import Redirector from '@slickdeals/durango/dist/javascript/utilities/redirector';
import { isMobile } from '../utilities/experience';
import { isMobileBreakpoint } from '../utilities/breakpoints';
export const name = 'DoubleLinkable';
const isDoubleLinkableOptions = (options) => typeof options === 'function';
/**
 * This decorator exposes functionality that enables a linkable element to send
 * the user to multiple links.
 */
export function doubleLinkable() {
    return (target) => {
        const { prototype: proto } = target;
        proto.activateDoubleLink = async function activateDoubleLink() {
            /**
             * LinkableButton stores state as attributes, so we support a method to retrieve options
             * from this or any state for now.
             */
            const { foregroundUrl, backgroundUrl } = isDoubleLinkableOptions(this.getDoubleLinkableOptions)
                ? this.getDoubleLinkableOptions()
                : this.options.doubleLinkableOptions;
            const isMobileExperience = await isMobile() || isMobileBreakpoint();
            if (isMobileExperience && backgroundUrl && foregroundUrl) {
                Redirector.open(foregroundUrl);
                Redirector.redirect(backgroundUrl);
                return;
            }
            if (backgroundUrl) {
                Redirector.open(backgroundUrl);
            }
            if (foregroundUrl) {
                Redirector.redirect(foregroundUrl);
            }
        };
    };
}
